// 导入请求数据的 request 模块
import request from '@/utils/request'

// 查询图片信息
export const selectPicture = () => {
  return request.get('/home/select')
}
